import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà donné son consentement
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Attendre un peu avant d'afficher pour ne pas bloquer la vue immédiatement
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 right-4 z-40 max-w-sm w-full sm:w-96">
      <div className="bg-white rounded-lg shadow-2xl border-2 border-gray-200 p-4 relative">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Fermer"
        >
          <X size={20} />
        </button>

        <div className="flex items-start space-x-3 mb-3">
          <div className="bg-primary-red/10 p-2 rounded-lg flex-shrink-0">
            <Cookie className="text-primary-red" size={24} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              Nous utilisons des cookies
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-3">
              Ce site utilise des cookies pour améliorer votre expérience et analyser l'utilisation du site. 
              En continuant, vous acceptez notre utilisation des cookies.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-2 mb-2">
          <button
            onClick={handleAccept}
            className="flex-1 bg-primary-red text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-primary-red-dark transition-colors"
          >
            Accepter
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-300 transition-colors"
          >
            Refuser
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center">
          <Link to="/cookies" data-discover="true" className="text-primary-red hover:underline">
            En savoir plus
          </Link>
        </p>
      </div>
    </div>
  );
};

export default CookieConsent;

